import React, { useState } from "react";
import axios from "axios";
import DefaultButton from "../../styles/materialButtonStyle";
import { fetchFilterData } from "../../../utils/fetchFilterData";
import { StyledExportButtonWrapper } from "./styledExportButton";
import userExportAuthenticationConfig from "../../../utils/userExportAuthenticationConfig";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { useTranslation } from "react-i18next";

const TransactionExportButton = ({ direction, filterData }) => {
  const { t } = useTranslation("otherInterface");
    const [notification, setNotification] = useState({
        visible: false,
        type: "",
        message: ""
    });

    const handleRetryCallback = () => {
        filterData.pagination = false;
        let filterUrl = fetchFilterData(filterData);
        axios.get(`/api/${direction}/export${filterUrl}`, userExportAuthenticationConfig()).then(response => {
            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${direction}_export_${Date.now()}.csv`);
                document.body.appendChild(link);
                link.click();
                delete filterData.pagination;
                setNotification(
                  { ...notification, visible: true, type: "success", message: t("exportButton.success") });
            }
        }).catch(error => {
            parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
        });
    };

    return (
      <StyledExportButtonWrapper>
          <DefaultButton
            title={t("exportButton.title")}
            className="export-btn"
            color="transparent"
            onClick={handleRetryCallback}
          >
              <span className="icon-light-down-arrow" />
          </DefaultButton>
      </StyledExportButtonWrapper>
    );
};

export default TransactionExportButton;